import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition, InputType } from "../../basic/update-add-table/update-add-table.component";


@Component({
  selector: 'app-roleright',
  imports: [UpdateAddTableComponent],
  templateUrl: './roleright.component.html',
  styleUrl: './roleright.component.scss',
})
export class RolerightComponent {
title = 'Auth role rights';
description = "This are the role rights of the App";
path = "/auth/roleright";
showFormAdd = true
element_name="roleright";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id' },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Description',      store_key: 'Description' },
{ title: 'Role',             store_key: 'Role.Name' , type: InputType.select,  options_path: "/auth/role"},
{ title: 'Right',            store_key: 'Right.Name' , type: InputType.select, options_path: "/auth/right"}
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
